import produce from 'immer';

import { RESET_ALL as RESET_ON_LOGOUT } from './common-reducer';

import { createReducer } from 'utils/redux';

import { UploadProgressReducerState } from 'redux-store/types/UploadProgressReducer.type';

const UPLOAD_PROGRESS_LOGGED = 'uploadProgress/LOGGED';
const UPLOAD_PROGRESS_RESET = 'uploadProgress/RESET';

const initialState: UploadProgressReducerState = {
  files: {}
};

export function setUploadProgress(fileId: string, progress: number) {
  return {
    type: UPLOAD_PROGRESS_LOGGED,
    payload: {
      fileId,
      progress
    }
  };
}

export function resetUploadProgress(fileId: string) {
  return {
    type: UPLOAD_PROGRESS_RESET,
    payload: {
      fileId
    }
  };
}

export default createReducer<UploadProgressReducerState, any>('uploadProgressReducer', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [UPLOAD_PROGRESS_LOGGED]: (state, { fileId, progress }) => produce(state, (draft) => {
    // eslint-disable-next-line no-param-reassign
    draft.files[fileId] = progress;
  }),
  [UPLOAD_PROGRESS_RESET]: (state, { fileId }) => produce(state, (draft) => {
    // eslint-disable-next-line no-param-reassign
    delete draft.files[fileId];
  })
});
